"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.borders = exports.fontSizes = exports.spaces = exports.lineHeights = void 0;
var lineHeights;

(function (lineHeights) {
  lineHeights["large7"] = "54px";
  lineHeights["large6"] = "48px";
  lineHeights["large5"] = "44px";
  lineHeights["large4"] = "40px";
  lineHeights["large3"] = "36px";
  lineHeights["large2"] = "32px";
  lineHeights["large1"] = "28px";
  lineHeights["normal"] = "24px";
  lineHeights["small1"] = "20px";
  lineHeights["small2"] = "16px";
  lineHeights["small3"] = "14px";
  lineHeights["small4"] = "12px";
})(lineHeights = exports.lineHeights || (exports.lineHeights = {}));

var spaces;

(function (spaces) {
  spaces["large12"] = "200px";
  spaces["large11"] = "160px";
  spaces["large10"] = "144px";
  spaces["large9"] = "128px";
  spaces["large8"] = "96px";
  spaces["large7"] = "80px";
  spaces["large6"] = "64px";
  spaces["large5"] = "48px";
  spaces["large4"] = "32px";
  spaces["large3"] = "24px";
  spaces["large2"] = "16px";
  spaces["large1"] = "12px";
  spaces["normal"] = "8px";
  spaces["small1"] = "4px";
  spaces["small2"] = "2px";
  spaces["small3"] = "1px";
})(spaces = exports.spaces || (exports.spaces = {}));

var fontSizes;

(function (fontSizes) {
  fontSizes["large9"] = "64px";
  fontSizes["large8"] = "48px";
  fontSizes["large7"] = "40px";
  fontSizes["large6"] = "36px";
  fontSizes["large5"] = "32px";
  fontSizes["large4"] = "28px";
  fontSizes["large3"] = "24px";
  fontSizes["large2"] = "20px";
  fontSizes["large1"] = "18px";
  fontSizes["normal"] = "16px";
  fontSizes["small1"] = "14px";
  fontSizes["small2"] = "12px";
  fontSizes["small3"] = "10px";
  fontSizes["small4"] = "8px";
})(fontSizes = exports.fontSizes || (exports.fontSizes = {}));

var borders;

(function (borders) {
  borders["small"] = "2px";
  borders["default"] = "4px";
  borders["extraRound"] = "16px";
  borders["circle"] = "50%";
})(borders = exports.borders || (exports.borders = {}));